// removed by extract-text-webpack-plugin
module.exports = {"avatar":"theme__avatar___c9zVU","image":"theme__image___38G1J","letter":"theme__letter___3L7GE"};


//////////////////
// WEBPACK FOOTER
// ./~/@luminopia/react-toolbox/lib/avatar/theme.css
// module id = 1185
// module chunks = 0